import React from 'react';
import Icon, { IconProps } from './Icon';

// load-balancer *
const DeploymentUnitOutlinedSvg: React.FC<React.SVGProps<SVGSVGElement>> = (
    props
) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 12H9.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.2998 12H20.9998"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 3V9.7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 14.3V21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.7002 4.6999L12.0002 2.3999L14.3002 4.6999"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.2002 9.69995L21.5002 12L19.2002 14.3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.3002 19.3999L12.0002 21.7999L9.7002 19.3999"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
const DeploymentUnitOutlined: React.FC<Omit<IconProps, 'component'>> = (props) => (
    <Icon
        component={DeploymentUnitOutlinedSvg}
        className="s9sicon-deployment-unit"
        {...props}
    />
);
export default DeploymentUnitOutlined;
